<template>
    <v-container class="profile-container">
        <v-card class="pa-6" flat>
            <!-- Header Section -->
            <div class="d-flex align-center mb-8">
                <!-- Avatar Upload Section -->
                <div class="avatar-upload">
                    <input type="file" ref="fileInput" accept="image/*" @change="onFileSelected" class="d-none">
                    <v-avatar size="100" class="avatar-preview" @click="$refs.fileInput.click()">
                        <template v-if="profile.avatarUrl">
                            <v-img :src="profile.avatarUrl" alt="Avatar"></v-img>
                        </template>
                        <template v-else>
                            <v-icon size="40" color="grey">mdi-account</v-icon>
                        </template>
                    </v-avatar>
                </div>
                <div>
                    <div class="text-h5 font-weight-bold text-left">{{ profile.name }}</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn v-if="!editingProfile" outlined @click="editProfile">
                    編輯
                </v-btn>
                <v-btn v-else color="black" dark @click="submitForm">
                    儲存
                </v-btn>
            </div>

            <!-- Profile Form -->
             <v-form>
                <v-row>
                    <!-- 姓名 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.name" label="姓名" outlined  :readonly="!editingProfile"></v-text-field>
                    </v-col>
                    <!-- 電話 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.phone" label="電話" outlined  :readonly="!editingProfile"></v-text-field>
                    </v-col>
                    <!-- 信箱 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.email" label="信箱" outlined  :readonly="!editingProfile"></v-text-field>
                    </v-col>
                    <!-- 帳號 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.username" label="帳號" outlined  :readonly="!editingProfile"></v-text-field>
                    </v-col>
                    <!-- 密碼 -->
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="profile.password"
                            label="密碼"
                            :type="showPassword ? 'text' : 'password'"
                            outlined
                            :readonly="!editingProfile"
                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="showPassword = !showPassword"
                        ></v-text-field>
                    </v-col>

                </v-row>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import userService from '../../services/user.service'
import baseUrl from '../../../baseUrl.config'
export default {
    name: 'AdminProfile',
    data() {
        return {
            editingProfile: false,
            showPassword: false,
            sexOptions:['男','女','其他'],
            profile: {
                name: '',
                phone: '',
                email: '',
                username: '',
                password: '',
                avatarUrl: null // 頭像URL
            }
        }
    },
    methods: {
        init() {
            userService.getUserInfo(localStorage.getItem('user_id')).then((res) => {
                this.profile = res.data
                if(this.profile.avatarUrl === undefined) {
                    this.profile.avatarUrl = null
                }else{
                    this.profile.avatarUrl = baseUrl  + res.data.avatarUrl
                }
            })
        },
        editProfile() {
            // 實現編輯功能
            this.editingProfile = true
        },
        submitForm() {
            if(this.profile.username === '') {
                alert('帳號不能為空')
                return
            }
            if(this.profile.password === '') {
                alert('密碼不能為空')
                return
            }
            this.editingProfile = false
            userService.updateUserInfo(localStorage.getItem('user_id'), this.profile).then(() => {
                this.init()
            })
        },
        onFileSelected(event) {
            const file = event.target.files[0];
            if (file) {
                // 預覽圖片
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.avatarPreview = e.target.result;
                };
                reader.readAsDataURL(file);
                // 這裡可以處理圖片上傳邏輯
                // 例如: this.uploadImage(file);
                this.uploadImage(file)
            }
        },
        // 可選：添加上傳圖片到服務器的方法
         uploadImage(file) {
            console.log(file)
            // 實現上傳邏輯
            const formData = new FormData();
            formData.append('avatar', file);
            userService.uploadAvatar(formData).then(() => {
                this.init();
                // 重新加載圖片，即使URL相同
                setTimeout(() => {
                    this.profile.avatarUrl =  this.profile.avatarUrl + '?t=' + new Date().getTime();
                },500);
            })
           
        }
    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped>
.profile-container {
    max-width: 1000px;
    margin: 0 auto;
    padding-top: 32px;
}

.v-text-field ::v-deep .v-input__slot {
    background-color: #f5f5f5 !important;
}
.avatar-upload {
    margin-right: 16px;
}

</style>